import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { MinimalFooterSocialLinks } from '@primer/react-brand';
import { PropTableValues } from '../../src/components';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {MinimalFooter} from '@primer/react-brand'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<MinimalFooter />
`}</code></pre>
    <h3>{`Footer links`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<MinimalFooter>
  <MinimalFooter.Link href="https://github.com/organizations/enterprise_plan">
    Try GitHub for free
  </MinimalFooter.Link>
  <MinimalFooter.Link href="https://github.com/enterprise">
    Enterprise
  </MinimalFooter.Link>
  <MinimalFooter.Link href="https://github.com/enterprise/contact">
    Email us
  </MinimalFooter.Link>
</MinimalFooter>
`}</code></pre>
    <h3>{`Footnotes`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<MinimalFooter>
  <MinimalFooter.Footnotes>
    <Text>
      <sup>1</sup>By signing up, GitHub may use your information to personalize
      and measure the effectiveness of enterprise business ads, including those
      you see off of GitHub, promotional communications or marketing you receive
      related to the Enterprise Marketing Pages. We will send you relevant
      emails and promotional information based on your GitHub profile and any
      additional information provided in the sign-up form. If you change your
      mind, you can unsubscribe at any time (an unsubscribe link is provided in
      every email). For more information on how GitHub uses your personal
      information, please see the{' '}
      <InlineLink
        href="https://docs.github.com/en/site-policy/privacy-policies/github-privacy-statement"
        target="_blank"
      >
        GitHub Privacy Statement
      </InlineLink>
      .
    </Text>
  </MinimalFooter.Footnotes>
</MinimalFooter>
`}</code></pre>
    <h3>{`Footer social links`}</h3>
    <p><inlineCode parentName="p">{`MinimalFooter`}</inlineCode>{` will render all supported social links by default. Social links can be removed however, by passing `}<inlineCode parentName="p">{`socialLinks={false}`}</inlineCode>{`. Alteratively, pass an array of valid social links to filter the default list.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`Hide all social links:
<MinimalFooter socialLinks={false} />
<br />
Only show GitHub social link:
<MinimalFooter socialLinks={['github']} />
`}</code></pre>
    <h2>{`Component props`}</h2>
    <h3>{`MinimalFooter`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom class on the root element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={['MinimalFooter.Link', 'MinimalFooter.Footnotes']} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Valid child components`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`copyrightStatement`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`ReactElement`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The copyright statement to be displayed in the footer.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`logoHref`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`'https://github.com'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The href for the GitHub logo.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`socialLinks`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`['twitter', 'github', 'linkedin', 'youtube', 'facebook', 'twitch', 'tiktok', 'instagram']`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`false`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`['twitter', 'github', 'linkedin', 'youtube', 'facebook', 'twitch', 'tiktok', 'instagram']`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Array of valid strings or `}<inlineCode parentName="td">{`false`}</inlineCode>{` to hide all links`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`MinimalFooter.Link`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`as`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`'a'`}</inlineCode>{`, `}<inlineCode parentName="td">{`'button'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`'a'`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Applies the underlying HTML element`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Link label text`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`MinimalFooter.Footnotes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ReactElement`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`undefined`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Use Primer Brand `}<inlineCode parentName="td">{`Text`}</inlineCode>{` components to benefit from inherited styling.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      